export const jobTypes = {
  JOBSINFO: 'job/jobData',
  JOBEDIT: 'job/jobEdit',
  JOBEDITCLEAR: 'job/JOBEDITCLEAR',
  jobsALL: 'job/jobsALL',
};

const editDataInit = {
  editData: {},
  isEdit: false,
  jobsView: []
};

export default (state = editDataInit, action) => {
  switch (action.type) {
    case jobTypes.JOBSINFO:
      return {
        ...state,
        ...action.payload,
      };
    case jobTypes.JOBEDIT:
      return {
        ...state,
        editData: action.payload,
        isEdit: true,
      };
    case jobTypes.JOBEDITCLEAR:
      return {
        ...state,
        editData: {},
        isEdit: false,
      };
    case jobTypes.jobsALL:
      return {
        ...state,
        jobsView: action.payload
      }
    default:
      return state;
  }
};
